import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-op-replace",
  "use": "icon-op-replace-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-op-replace\"><path d=\"M5 3c.6 0 1 .4 1 1v2c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1V4c0-.6.4-1 1-1zm0-1H3c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m3 10-2-2v1.5H5c-.3 0-.5-.2-.5-.5V9h-1v2c0 .8.7 1.5 1.5 1.5h1V14zm3-8.5h-1V2L8 4l2 2V4.5h1c.3 0 .5.2.5.5v2h1V5c0-.8-.7-1.5-1.5-1.5M13 9c.6 0 1 .4 1 1v2c0 .6-.4 1-1 1h-2c-.6 0-1-.4-1-1v-2c0-.6.4-1 1-1zm0-1h-2c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol